import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function IconButton({
  icon,
  title,
  disabled = false,
  onClick,
}: {
  icon: IconDefinition;
  title: string;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <button
      aria-label={title}
      className="px-2 py-1 text-gray-600 hover:text-gray-900 cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
      disabled={disabled}
      title={title}
      type="button"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}
